module.exports = __webpack_public_path__ + "static/media/joel@3x.a84838c5.png";